import { createSlice } from "@reduxjs/toolkit";

const storeSlice = createSlice({
  name: "store",
  initialState: {
    stores: [],
    loading: false,
    error: null,
    total: 0,
  page: 0,
  limit: 5,
  },
  reducers: {
    // edit store
    updateStoreRequest: (state, action) => {
      state.loading = true;
    },
    updateStoreSuccess: (state, action) => {
      state.loading = false;
    },
    updateStoreFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    // get store
    fetchStoresRequest: (state) => {
      state.loading = true;
    },
fetchStoresSuccess: (state, action) => {
  state.loading = false;
  state.stores = action.payload.data || [];
  state.total = action.payload.total || 0;
  state.page = action.payload.page || 0;
  state.limit = action.payload.limit || 5;
},
    fetchStoresFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    // create store
    createStoreRequest: (state) => {
      state.loading = true;
    },
    createStoreSuccess: (state) => {
      state.loading = false;
    },
    createStoreFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    resetStoreSuccess: (state) => {
      state.success = false;
    },
    // delete store
    deleteStoreRequest: (state) => {
      state.loading = true;
    },
    deleteStoreSuccess: (state, action) => {
      state.loading = false;
      // Optional: Remove deleted store from state
      state.stores = state.stores.filter(
        (store) => store._id !== action.payload
      );
    },
    deleteStoreFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const {
  fetchStoresRequest,
  fetchStoresSuccess,
  fetchStoresFailure,
  createStoreRequest,
  createStoreSuccess,
  deleteStoreRequest,
  deleteStoreSuccess,
  deleteStoreFailure,
  updateStoreRequest,
  updateStoreSuccess,
  updateStoreFailure,
  createStoreFailure,
  resetStoreSuccess,
} = storeSlice.actions;

export default storeSlice.reducer;
